import moment from 'moment';
import React from 'react';
import { View, Image } from 'react-native';
import Colors from '../../../constants/Colorsv2';
import { TouchableOpacity, Text } from '../../../globalComponents/NativeOverrides';
import { ArticleFeedProps } from '../../../store/types/soc_svc';


type ArticleFeedCardProps = {
    article_feed:ArticleFeedProps,
    width: number,
    onArticleFeedPress: (article_feed:ArticleFeedProps) => void
}
const ArticleFeedCard = ({ article_feed, width, onArticleFeedPress }:ArticleFeedCardProps) => {

    const handleArticleFeedPress = () => {
        if(!onArticleFeedPress){ return }
        onArticleFeedPress(article_feed)
    }


    let article_image = article_feed.feed_image?.url
    if(!article_image || article_image == ''){
        article_image = require('../../../assets/images/default_feed.webp')
    }
    if(width === 0){ return <></> }

    return (
        <TouchableOpacity style={{ margin:5, maxWidth:150, backgroundColor:Colors.shades.white, borderRadius:4 }} onPress={() => handleArticleFeedPress()}>
            <Image source={article_image} style={{ height:150, width:150 }} resizeMode='cover' />
            <View style={{ margin:4, padding:5 }}>
                <Text size={14} weight='semibold' color={Colors.shades.black}>{article_feed.feed_name}</Text>
                <Text size={12} weight='light' color={Colors.shades.black}>{moment(article_feed.last_update_datetime).format('dddd')}</Text>
            </View> 
        </TouchableOpacity>
    )
}

export default ArticleFeedCard